export default function logApiURL() {
  switch (process.env.REACT_APP_STAGE) {
    case "local":
      return process.env.REACT_APP_API_LOCAL
    case "develop":
      return process.env.REACT_APP_API_DEV
    case "prod":
      return process.env.REACT_APP_API_PROD
    default:
      return process.env.REACT_APP_API_LOCAL
  }
}
